import { serializeChartBundleForSnapshot } from './chartDataSnapshot';
import { DASHBOARD_CHART_BOARD } from './statisticsPersistedCharts';

export const CHART_REFRESH_MODE = {
	LIVE: 'live',
	FROZEN: 'frozen',
};

export const isFrozenChartSnapshot = (snapshot = {}) => snapshot?.refreshMode === CHART_REFRESH_MODE.FROZEN;

export const isLiveChartSnapshot = (snapshot = {}) => !snapshot?.refreshMode || snapshot.refreshMode === CHART_REFRESH_MODE.LIVE;

export const attachLiveRefreshMode = (snapshot = {}) => ({
	...snapshot,
	refreshMode: CHART_REFRESH_MODE.LIVE,
});

export const attachFrozenDataSnapshot = (snapshot = {}, chartBundle) => {
	const chartKind = snapshot?.chartKind;
	const dataSnapshot = serializeChartBundleForSnapshot(chartBundle, chartKind);
	return {
		...snapshot,
		refreshMode: CHART_REFRESH_MODE.FROZEN,
		pinnedAt: new Date().toISOString(),
		...(dataSnapshot ? { dataSnapshot } : {}),
	};
};

export const formatPinnedAtLabel = (pinnedAt) => {
	if (!pinnedAt) return '';
	const date = new Date(pinnedAt);
	if (Number.isNaN(date.getTime())) return '';
	return date.toLocaleString('zh-CN', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
	});
};

/** 图表是否跟统计页顶栏已应用筛选（首页与已保存口径图均为 false） */
export const isPageBoundChartSnapshot = (snapshot = {}) =>
	snapshot?.board !== DASHBOARD_CHART_BOARD.HOME && Boolean(snapshot?.usesPageFilters);

/** 筛选绑定维度：跟筛选 vs 固定口径 */
export const resolveDashboardChartBindingLabel = (snapshot = {}) => {
	if (isPageBoundChartSnapshot(snapshot)) {
		return {
			short: '跟筛选',
			title: '随统计页顶栏已应用筛选变化',
		};
	}
	return {
		short: '固定口径',
		title:
			snapshot?.board === DASHBOARD_CHART_BOARD.HOME
				? '按固定至首页时的筛选口径展示，不随统计页当前筛选变化'
				: '按保存时的筛选口径展示，不随统计页当前筛选变化',
	};
};

/** 数据时效维度：实时刷新 vs 定格快照 */
export const resolveDashboardChartRefreshLabel = (snapshot = {}) => {
	if (isFrozenChartSnapshot(snapshot)) {
		const pinnedLabel = snapshot?.pinnedAt ? formatPinnedAtLabel(snapshot.pinnedAt) : '';
		return {
			short: '定格',
			title: pinnedLabel ? `已定格为快照（${pinnedLabel}），数字不再实时变化` : '已定格为快照，数字不再实时变化',
			badgeBg: 'warning',
		};
	}

	const binding = resolveDashboardChartBindingLabel(snapshot);
	return {
		short: '实时',
		title: binding.short === '跟筛选' ? '随统计页顶栏已应用筛选持续拉取最新数据' : '按固定口径持续拉取最新数据',
		badgeBg: 'success',
	};
};
